import React from 'react';
import { Disc3, Layers, Music, ArrowRight, Check } from 'lucide-react';

const RELEASE_TYPES = [
  {
    id: 'single',
    name: 'Single',
    tracks: 'Exactly 1 Track',
    desc: 'Release a standalone single song to 150+ digital streaming platforms worldwide.',
    icon: Disc3,
  },
  {
    id: 'ep',
    name: 'EP (Extended Play)',
    tracks: '2 to 6 Tracks',
    desc: 'A mini-album or extended collection of multiple original tracks with unified cover artwork.',
    icon: Layers,
  },
  {
    id: 'album',
    name: 'Album / LP',
    tracks: '7+ Tracks',
    desc: 'Full-length album project with dynamic track sequencing, comprehensive performer credits, and global delivery.',
    icon: Music,
  },
];

export default function Step1ReleaseType({ selectedType, onSelectType, onContinue }) {
  return (
    <div className="dist-card" role="region" aria-label="Release format selection">
      <div className="dist-card-header">
        <div>
          <div className="dist-card-title-row">
            <div className="dist-header-icon-badge" aria-hidden="true">
              <Disc3 size={20} color="#d9fb06" />
            </div>
            <h2 className="dist-card-title">What are you releasing?</h2>
          </div>
          <p className="dist-card-desc">
            Select your release format.
          </p>
        </div>
      </div>

      <div className="dist-release-type-grid" role="radiogroup" aria-label="Release Type Selection">
        {RELEASE_TYPES.map((type) => {
          const IconComp = type.icon;
          const isSelected = selectedType === type.id;

          return (
            <div
              key={type.id}
              className={`dist-type-card ${isSelected ? 'selected' : ''}`}
              onClick={() => onSelectType(type.id)}
              role="radio"
              aria-checked={isSelected}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                  e.preventDefault();
                  onSelectType(type.id);
                }
              }}
            >
              <div className={`dist-type-radio-check ${isSelected ? 'selected' : ''}`} aria-hidden="true">
                {isSelected && <Check size={13} strokeWidth={3} />}
              </div>

              <div className={`dist-type-icon-wrapper ${isSelected ? 'selected' : ''}`} aria-hidden="true">
                <IconComp size={22} color={isSelected ? '#0a0a0a' : '#d9fb06'} />
              </div>

              <h3 className="dist-type-name">{type.name}</h3>
              <span className="dist-type-tracks">{type.tracks}</span>
              <p className="dist-type-desc">{type.desc}</p>
            </div>
          );
        })}
      </div>

      <div className="dist-footer-actions dist-step1-footer">
        <button
          type="button"
          className="dist-btn-primary"
          onClick={onContinue}
          disabled={!selectedType}
          aria-label="Continue to Audio Upload"
        >
          <span>Continue to Audio Upload</span>
          <ArrowRight size={18} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
